void (async () => {
  if (!document) {
    return;
  }

  if (
    !document.location.search.match("forceCookies") &&
    document.documentElement?.getAttribute("data-consent") === "1"
  ) {
    return;
  }

  const { loadCookieConsent } = await import("@bn-monorepo/js-packages");
  await loadCookieConsent(window?.document);
})();
